export default "__VITE_ASSET__CFuysSdH__"